import Hero from "../components/sections/Hero";
import About from "../components/sections/About";
import ProgramsSection from "../components/sections/ProgramsSection";
import Shlokas from "../components/sections/Shlokas";
import WhyChooseUs from "../components/sections/WhyChooseUs";
import GallerySection from "../components/sections/GallerySection";
import Testimonials from "../components/sections/Testimonials";
import FAQSection from "../components/sections/FAQSection";
import CTA from "../components/sections/CTA";
import StatsBar from "../components/sections/StatsBar";
import BrandedShowcase from "../components/sections/BrandedShowcase";
import BlogSection from "../components/sections/BlogSection";
import VideoSection from "../components/sections/VideoSection";
import Countdown from "../components/sections/Countdown";
import ThoughtOfTheDay from "../components/sections/ThoughtOfTheDay";
import WeeklyJourneyInfographic from "../components/infographics/WeeklyJourneyInfographic";
import FounderMessage from "../components/sections/FounderMessage";
import ParentSayTicker from "../components/sections/ParentSayTicker";

const Home = () => {
  return (
    <div>
      <Hero />
      <StatsBar />
      <ThoughtOfTheDay />
      <About />
      <FounderMessage />
      <ProgramsSection />
      <WeeklyJourneyInfographic />
      <BrandedShowcase />
      <VideoSection />
      <Countdown />
      <Shlokas />
      <WhyChooseUs />
      <GallerySection />
      <ParentSayTicker />
      <Testimonials />
      <BlogSection />
      <FAQSection />
      <CTA />
    </div>
  );
};

export default Home;
